/* eslint-disable quotes */
import i18n from '.';
import { trainerTitle } from './translations';

export const durationLabel = (): string =>
  i18n._translate('Duration', {
    context: 'How long a workout takes to complete.',
  });

export const durationLabelPlural = (): string =>
  i18n._translate('All Durations', {
    context:
      'Selecting this filter option shows all workouts, regardless of how long they take to complete.',
  });

export const trainerLabel = trainerTitle;

export const trainerLabelPlural = (): string =>
  i18n._translate('All Trainers', {
    context:
      'Selecting this filter option shows all workouts, regardless of what trainer is leading the workout.',
  });

export const workoutTypeLabel = (): string =>
  i18n._translate('Workout Type', {
    context:
      'Which workout type a workout is. (Running, Walking, or Studio for example.)',
  });

export const workoutTypeLabelPlural = (): string =>
  i18n._translate('All Workout Types', {
    context:
      'Selecting this filter option shows all workouts, regardless of which workout type it is. (Running, Walking, or Studio for example.)',
  });

export const intensityLabel = (): string =>
  i18n._translate('Intensity', {
    context: 'How intense a workout is.',
  });

export const intensityLabelPlural = (): string =>
  i18n._translate('All Intensities', {
    context:
      'Selecting this filter option shows all workouts, regardless of intensity.',
  });

export const targetAreaLabel = (): string =>
  i18n._translate('Target Area', {
    context:
      'What area of the body a workout targets. (Arms, Back, or Legs for example.)',
  });

export const targetAreaLabelPlural = (): string =>
  i18n._translate('All Target Areas', {
    context:
      'Selecting this filter option shows all workouts, regardless of what area of the body it targets. (Arms, Back, or Legs for example.)',
  });

export const continentLabel = (): string =>
  i18n._translate('Continent', {
    context: 'What continent a workout takes place in.',
  });

export const continentLabelPlural = (): string =>
  i18n._translate('All Continents', {
    context:
      'Selecting this filter option shows all workouts, regardless of what continent it takes place on.',
  });

export const locationLabel = (): string =>
  i18n._translate('Environment', {
    context:
      'What environment a workout takes place in. (Beach or City for example.)',
  });

export const locationLabelPlural = (): string =>
  i18n._translate('All Environments', {
    context:
      'Selecting this filter option shows all workouts, regardless of what environment it takes place in. (Beach or City for example.)',
  });

export const requiredEquipmentLabel = (): string =>
  i18n._translate('Other Equipment', {
    context:
      'What other equipment is required to do a workout. (Yoga Mat or Kettlebell for example.)',
  });

export const requiredEquipmentLabelPlural = (): string =>
  i18n._translate('All Other Equipment', {
    context:
      'Selecting this filter option shows all workouts, regardless of what other equipment is required. (Yoga Mat or Kettlebell for example.)',
  });

export const completedLabel = (): string =>
  i18n._translate('Completed', {
    context:
      'Whether or not the user has already completed a workout or series (a collection of workouts).',
  });

export const completedLabelPlural = (): string =>
  i18n._translate('All Included', {
    context:
      'Selecting this filter option shows all workouts and series (a collection of workouts), regardless of whether or not they have been completed.',
  });

export const languageLabel = (): string =>
  i18n._translate('Language', {
    context: 'The language a trainer speaks during a workout.',
  });

export const languageLabelPlural = (): string =>
  i18n._translate('All Languages', {
    context:
      'Selecting this filter option shows all workouts, regardless of what language a trainer speaks.',
  });

export const lessThanMinutes = (numberOfMinutes: number): string =>
  i18n._translate('Less than %{numberOfMinutes} min', {
    context: 'The workout takes less than numberOfMinutes to complete.',
    numberOfMinutes,
  });

export const rangeOfMinutes = (
  lowerLimit: number,
  upperLimit: number,
): string =>
  i18n._translate('%{lowerLimit}-%{upperLimit} min', {
    context:
      'The workout takes between upperLimit and lowerLimit minutes to complete.',
    lowerLimit,
    upperLimit,
  });

export const greaterThanMinutes = (numberOfMinutes: number): string =>
  i18n._translate('%{numberOfMinutes}+ min', {
    context: 'The workout takes greater than numberOfMinutes to complete.',
    numberOfMinutes,
  });

export const intensityLevelBeginner = (): string =>
  i18n._translate('Beginner', {
    context:
      'An intensity level. This is a measure of how intense a workout is. A "beginner" tag implies that a certain workout or series of workouts was made to appeal to the skill level of an inexperienced athlete.',
  });

export const intensityLevelIntermediate = (): string =>
  i18n._translate('Intermediate', {
    context:
      'An intensity level. This is a measure of how intense a workout is. An "intermediate" tag implies that a certain workout or series of workouts was made to appeal to the skill level of a mid-level athlete.',
  });

export const intensityLevelAdvanced = (): string =>
  i18n._translate('Advanced', {
    context:
      'An intensity level. This is a measure of how intense a workout is. An "advanced" tag implies that a certain workout or series of workouts was made to appeal to the skill level of an experienced athlete.',
  });

export const onlyCompletedText = (): string =>
  i18n._translate('Only Completed', {
    context:
      'Only show workouts and series (which are a collection of workouts) that the user has already completed.',
  });

export const excludeCompletedText = (): string =>
  i18n._translate('Exclude Completed', {
    context:
      'Only show workouts and series (which are are a collection of workouts) that the user has not already completed.',
  });

export const searchPlaceholderText = (): string =>
  i18n._translate('Search for title, trainer, or workout type', {
    context:
      'The placeholder text for a search field, which allows the user to find workouts and series by typing in whatever they want. We search for matching titles, trainers, workout types, and more. We limit the placeholder text to only those 3 types of searches to help guide the user.',
  });

export const workoutSeriesTitle = (): string =>
  i18n._translate('Workout/Series', {
    context:
      'The title for a search filter that allows you to see only series or only workouts',
  });
